/*
Generic atomic-unit link service.
Wraps:
  GET/PUT /api/v1/rsk/risks/{id}/{causes|impacts|controls}
  GET/PUT /api/v1/ctr/controls/{id}/{risks|procedures}
*/

import apiClient from './apiService';

export interface LinkedItem {
  id: number;
  code?: string;
  name: string;
  description?: string;
  step_number?: number;
  process_id?: number;
}

export type RiskLinkType = 'causes' | 'impacts' | 'controls';
export type ControlLinkType = 'risks' | 'procedures';

export const linkService = {
  async listForRisk(riskId: number, kind: RiskLinkType): Promise<LinkedItem[]> {
    const r = await apiClient.get(`/api/v1/rsk/risks/${riskId}/${kind}`);
    return Array.isArray(r.data?.data) ? r.data.data : [];
  },
  async listProcessesViaControls(riskId: number): Promise<Array<LinkedItem & { via_controls?: string }>> {
    const r = await apiClient.get(`/api/v1/rsk/risks/${riskId}/processes-from-controls`);
    return Array.isArray(r.data?.data) ? r.data.data : [];
  },
  async replaceForRisk(riskId: number, kind: RiskLinkType, ids: number[]): Promise<void> {
    await apiClient.put(`/api/v1/rsk/risks/${riskId}/${kind}`, { ids });
  },
  async listForControl(controlId: number, kind: ControlLinkType): Promise<LinkedItem[]> {
    const r = await apiClient.get(`/api/v1/ctr/controls/${controlId}/${kind}`);
    return Array.isArray(r.data?.data) ? r.data.data : [];
  },
  async replaceForControl(controlId: number, kind: ControlLinkType, ids: number[]): Promise<void> {
    await apiClient.put(`/api/v1/ctr/controls/${controlId}/${kind}`, { ids });
  },
};

export default linkService;
